import axios from '@/plugins/axios.js'

export function list(params) {
    return axios.get("/orderPlan/query", { params: params });
}